
import { z } from "zod";
import { format } from "date-fns";

export const formSchema = z.object({
  title: z.string().min(2, "Title must be at least 2 characters"),
  description: z.string().optional(),
  start_date: z.date({
    required_error: "Start date is required",
  }),
  start_time: z.string().min(1, "Start time is required"),
  end_date: z.date({
    required_error: "End date is required",
  }),
  end_time: z.string().min(1, "End time is required"),
  location: z.string().optional(),
  organizer: z.string().optional(),
  website: z.string().url("Invalid URL").optional().or(z.literal("")),
  category: z.string().optional(),
}).refine(
  data => {
    const startDateTime = new Date(
      `${format(data.start_date, "yyyy-MM-dd")}T${data.start_time}`
    );
    const endDateTime = new Date(
      `${format(data.end_date, "yyyy-MM-dd")}T${data.end_time}`
    );
    return endDateTime >= startDateTime;
  },
  {
    message: "End date and time must be after start date and time",
    path: ["end_date"],
  }
);

export type FormValues = z.infer<typeof formSchema>;
